
import { GETARTICLEVARIANTIMAGELIST_TYPES } from '../actions/getArticleVariantImageList'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(GETARTICLEVARIANTIMAGELIST_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer